/**
 * Module dependencies.
 */

import React, { useCallback } from 'react';
import styled from 'styled-components';
import { Button } from '../button/button';
import notification from 'antd/lib/notification';
import { FaRegCopy } from 'react-icons/fa6';
import { useTranslation } from 'react-i18next';

/**
 * `Props` type.
 */

type Props = {
  children: string;
};

/**
 * `Wrapper` styled component.
 */

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

/**
 * `Content` styled component.
 */

const Content = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 300px;
`;

/**
 * Export `ApiKey` component.
 */

export function ApiKey({ children }: Props): JSX.Element {
  const [api, contextHolder] = notification.useNotification();
  const [translate] = useTranslation();
  const handleClick = useCallback(
    async (event: any) => {
      try {
        event.stopPropagation();

        await navigator.clipboard.writeText(children);

        api.success({
          key: `success-${new Date().getTime()}`,
          message: 'API Key copiado com sucesso'
        });
      } catch (err) {
        console.error('Falha ao copiar: ', err);
      }
    },
    [api, children]
  );

  return (
    <>
      {contextHolder}

      <Wrapper>
        <Content>{children}</Content>

        <Button icon={<FaRegCopy style={{ marginRight: 8, top: 1, position: 'relative' }} />} onClick={handleClick}>
          {translate('common.actions.copy')}
        </Button>
      </Wrapper>
    </>
  );
}
